module.exports = __webpack_public_path__ + "img/isfp-selected.c41af67d.png";